// extracted by mini-css-extract-plugin
export default {"container":"CouponPill_container__C0eEr","icon":"CouponPill_icon__G51bf","title":"CouponPill_title__kHOiy","body":"CouponPill_body__xoETa"};